/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { useDispatch } from 'react-redux';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import OrgAuthProviderForm from './OrgAuthProviderForm';
import { createOrgAuthProvider } from '../../../../../../../services/organization/OrgAuthProvider';
import { getAllOrgsAuthProviders, getAllOrgsAuthProvidersByOrgID } from '../../../../../../../store/reducers/organization/orgAuthProvider/orgAuthProviderAction';

const OrgAuthProviderCreation = ({ handleClose }) => {
    const { orgid } = useParams()
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, authProviderID }) => {
        try {
            await createOrgAuthProvider({ organizationID, authProviderID });
            toast.success('Organization Identity Provider was registred successfully');
            handleClose();
            if(orgid?.length>0){
                await dispatch(getAllOrgsAuthProvidersByOrgID({ 'organizationID': orgid })).unwrap();

            }else{
                await dispatch(getAllOrgsAuthProviders()).unwrap();

            }
        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

        }
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Identity Provider Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid : '',
                    authProviderID: ''
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    authProviderID: Yup.string().required('Identity Provider is required.')

                })}
                onSubmit={(
                    values
                ) => {
                    handleSubmit(values)
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgAuthProviderForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}


export default OrgAuthProviderCreation;